import { useEffect } from "react";

const BUTTONS_SELECTOR = [
    ".main-content .config-header .header-buttons",
    ".admin-sensors-shell .config-header .header-buttons",
    ".wr-polls-page > .config-header .header-buttons",
].join(", ");

function updateHeader(buttons) {
    const header = buttons.closest(".config-header");
    if (!header) return;

    const maxScroll = buttons.scrollWidth - buttons.clientWidth;
    const scrollable = maxScroll > 2;
    const canLeft = scrollable && buttons.scrollLeft > 2;
    const canRight = scrollable && buttons.scrollLeft < maxScroll - 2;

    header.classList.toggle("dock-scrollable", scrollable);
    header.classList.toggle("dock-scroll--left", canLeft);
    header.classList.toggle("dock-scroll--right", canRight);
}

export default function DockScrollHints() {
    useEffect(() => {
        let disposed = false;
        let scanTimer = 0;
        const cleanups = new Map();

        const bind = (el) => {
            if (cleanups.has(el)) {
                updateHeader(el);
                return;
            }

            const onScroll = () => updateHeader(el);
            el.addEventListener("scroll", onScroll, { passive: true });

            const ro = typeof ResizeObserver !== "undefined"
                ? new ResizeObserver(() => updateHeader(el))
                : null;
            ro?.observe(el);

            cleanups.set(el, () => {
                el.removeEventListener("scroll", onScroll);
                ro?.disconnect();
                const header = el.closest(".config-header");
                header?.classList.remove("dock-scrollable", "dock-scroll--left", "dock-scroll--right");
            });

            updateHeader(el);
        };

        const scan = () => {
            if (disposed) return;
            const nodes = document.querySelectorAll(BUTTONS_SELECTOR);
            const live = new Set(nodes);

            for (const [el, cleanup] of cleanups.entries()) {
                if (!live.has(el)) {
                    cleanup();
                    cleanups.delete(el);
                }
            }

            nodes.forEach(bind);
        };

        const scheduleScan = () => {
            window.clearTimeout(scanTimer);
            scanTimer = window.setTimeout(scan, 40);
        };

        scan();
        const mo = typeof MutationObserver !== "undefined"
            ? new MutationObserver(scheduleScan)
            : null;
        mo?.observe(document.body, { childList: true, subtree: true });
        window.addEventListener("resize", scheduleScan);

        return () => {
            disposed = true;
            window.clearTimeout(scanTimer);
            mo?.disconnect();
            window.removeEventListener("resize", scheduleScan);
            for (const cleanup of cleanups.values()) cleanup();
            cleanups.clear();
        };
    }, []);

    return null;
}
